import {
    FETCH_DRAW_CONFIG,
    LIST_DRAW_CONFIG, SHOW_DRAW_CONFIG,
    UPDATE_DRAW_CONFIG
} from "./types";

const init = {
    isLoading: true,
    data: [],
    showData: {},
    page: 1,
    totals: 0,
    size: 25
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DRAW_CONFIG:
            return {
                ...state,
                isLoading: true
            };
        case LIST_DRAW_CONFIG:
            return {
                ...state,
                ...payload,
                data: payload.data || [],
                isLoading: false
            };
        case UPDATE_DRAW_CONFIG:
            return {
                ...state,
                isLoading: false
            };
        case SHOW_DRAW_CONFIG:
            return {
                ...state,
                showData: payload.data || {},
                isLoading: false
            };
        default:
            return state;
    }
};
